import type { FaireProductEntity } from "../../entity_types/product";

export const p_9z9dtry8gp: FaireProductEntity = {
  token: "p_9z9dtry8gp",
  type: "product",
  name: "Lunakai Magnesium Glycinate Gummies 426mg with L‑Theanine",
  brandToken: "b_wef5szym8e",
  brandName: "AlchePharma Naturals",
  imageUrl:
    "https://cdn.faire.com/fastly/1c94e8b0d606861a14259b7e15a26a4fc5bc4d83a333f11dcaf6a08cd3ce6bf2.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/162e888cb58fff1c0be4467c0a219d569c2c466b5ef40c2e0d9f056d121a6f8d.jpeg",
    "https://cdn.faire.com/fastly/3a89d4681b94a81d82c3112e97bc7d307cb9e72d4409c67bce92327c3f192e74.jpeg",
    "https://cdn.faire.com/fastly/2af24bc2528a3d83d2e681017f90a4f46a6a3b6e5abcbd5b59c16ba4d3ceef0c.jpeg",
    "https://cdn.faire.com/fastly/3af4f5c1e878bb839a62c6837dbfb9523a044df1980cc80b557e2c6014c6fa2a.jpeg",
    "https://cdn.faire.com/fastly/32886b24fb8190f0da683b71376267692be46ea957df48b610f1e3cb1c8f6193.jpeg",
    "https://cdn.faire.com/fastly/29cfd1970c52f7aaa152d5dbf178ff374f3217edde70d0472b7537cb99a0ca59.jpeg",
    "https://cdn.faire.com/fastly/ec7e62cde14bd675709e3da87f4cb1136a05e210854b6fac5b0a8917f8c6516d.jpeg",
  ],
  priceDollars: 12.97,
  description:
    "Lunakai Magnesium Glycinate + L-Theanine Gummies deliver a tasty, chewable way to support relaxation, calmness, and restful sleep. Each serving combines highly absorbable magnesium glycinate with L-Theanine to promote muscle comfort and nervous system balance, helping the body unwind at the end of the day. Vegan, non-GMO, and gluten-free, these wildberry-flavored gummies make daily supplementation simple and enjoyable for adults and kids alike.",
  tags: [],
  msrpDollars: 25.94,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:56.682Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
